module.exports = __webpack_public_path__ + "img/alarm.cecb3265.svg";